import React from 'react';
import { TrendingUpIcon } from 'lucide-react';
import { AnimatedSection, AnimatedItem } from './AnimatedSection';
import { GoldButton } from './GoldButton';
export function ProofSection() {
  return <section className="w-full bg-navy-900" data-id="element-277">
      <div className="max-w-5xl mx-auto px-5 sm:px-8 py-20 md:py-28" data-id="element-278">
        <AnimatedSection data-id="element-279">
          <AnimatedItem data-id="element-280">
            <div className="flex items-center gap-3 mb-4" data-id="element-281">
              <div className="h-px flex-1 max-w-[60px] bg-gold-500/40" data-id="element-282" />
              <span className="text-gold-400 text-xs font-body font-semibold tracking-[0.2em] uppercase" data-id="element-283">
                Resultados
              </span>
            </div>
          </AnimatedItem>

          <AnimatedItem data-id="element-284">
            <h2 className="font-display text-2xl sm:text-3xl md:text-4xl font-bold text-white leading-tight" data-id="element-285">
              ¿Qué cambia en <span className="text-gold-400" data-id="element-286">30 días?</span>
            </h2>
          </AnimatedItem>

          <AnimatedItem data-id="element-287">
            <div className="mt-10 p-8 md:p-10 rounded-2xl bg-gradient-to-br from-navy-700 via-navy-800 to-navy-700 border border-gold-500/15 shadow-xl relative overflow-hidden" data-id="element-288">
              {/* Decorative glow */}
              <div className="absolute top-0 right-0 w-48 h-48 bg-gold-500/5 rounded-full blur-[80px] pointer-events-none" data-id="element-289" />

              <div className="relative" data-id="element-290">
                <div className="flex items-center gap-3 mb-6" data-id="element-291">
                  <div className="w-12 h-12 rounded-xl bg-gold-500/10 flex items-center justify-center" data-id="element-292">
                    <TrendingUpIcon className="w-6 h-6 text-gold-400" aria-hidden="true" data-id="element-293" />
                  </div>
                  <h3 className="font-display text-xl md:text-2xl font-bold text-gold-300" data-id="element-294">
                    Tu Primer Mes con el Plan Retiro
                  </h3>
                </div>

                <p className="text-slate-300 font-body text-base md:text-lg leading-relaxed mb-4" data-id="element-295">
                  Al aplicar el Plan Retiro, dejas de ser un espectador. En tu
                  primer mes, verás tu primer depósito de flujo de caja generado
                  por la venta de primas.
                </p>

                <p className="text-white font-body text-base md:text-lg leading-relaxed font-medium" data-id="element-296">
                  No es una promesa de valor futuro; es{' '}
                  <span className="text-gold-300" data-id="element-297">
                    dinero que entra a tu poder de compra desde el primer día
                  </span>{' '}
                  que ejecutas la estrategia. Tu cuenta deja de ser un número
                  estático y se convierte en una{' '}
                  <span className="text-gold-300 font-semibold" data-id="element-298">
                    máquina de rentas
                  </span>
                  .
                </p>
              </div>
            </div>
          </AnimatedItem>

          <AnimatedItem data-id="element-299">
            <div className="mt-10 text-center" data-id="element-300">
              <GoldButton data-id="element-301">Quiero Mi Plan Retiro Ahora</GoldButton>
            </div>
          </AnimatedItem>
        </AnimatedSection>
      </div>

      <div className="h-px bg-gradient-to-r from-transparent via-gold-500/20 to-transparent" data-id="element-302" />
    </section>;
}